
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/cookie",
      function () {
        return require("private-next-pages/services/cookie.tsx");
      }
    ]);
  